import type { RouteObject } from 'react-router';

import type { RouteHandle } from '@/hooks/useRouteHandle';

const page = (name: string) => () =>
  import(`./pages/${name}.tsx`).then((m) => ({ Component: m[name] }));

/**
 * 기업 공고 찾기(specs/069) — 기업 셀프 묶음(COMPANY_HOME) 아래 판정 기능(COMPANY_JUDGEMENT). `RequireRouteFeature` 가 매칭 경로의
 * 기능을 모두 요구하므로 두 기능을 가진 축만 들어온다(축 분기 없음 — research R5).
 */
export const companyJudgementRoutes: RouteObject[] = [
  {
    path: 'my-announcements',
    handle: { feature: 'COMPANY_HOME' } satisfies RouteHandle,
    children: [
      {
        index: true,
        lazy: page('MyAnnouncementsPage'),
        handle: { title: '공고 찾기', feature: 'COMPANY_JUDGEMENT' } satisfies RouteHandle,
      },
    ],
  },
];
